module.exports = __webpack_public_path__ + "assets/e1019afd8917f63961049fe8ae12b35e.svg";